/**
 * Tema compartilhado dos graficos (Recharts): series, dica, eixo e grade.
 * Usado por DashboardCard, PieChartCard, BarChartCard e por qualquer tela com
 * Recharts.
 *
 * Toda cor e `hsl(var(--…))` de ui/estilos/tokens.css, nunca valor fixo
 * (regra 2 de interface): o grafico acompanha o tema claro, o escuro e o alto
 * contraste sem saber que eles existem. Os valores de --chart-1..6 e a razao de
 * contraste de cada um sobre o cartao estao em tokens.css, conferidos por
 * scripts/auditar-contraste.ts.
 *
 * As series sao elemento grafico (3:1). Texto dentro do grafico — rotulo,
 * legenda, dica — vai em --card-foreground/--popover-foreground, nunca na cor
 * da serie, porque texto pede 4,5:1.
 */

/** As seis series, na ordem em que entram. */
export const PIE_COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
  'hsl(var(--chart-6))',
];

export const TOOLTIP_STYLE: React.CSSProperties = {
  background: 'hsl(var(--popover))',
  color: 'hsl(var(--popover-foreground))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '12px',
  fontSize: '12px',
  // --overlay e escuro nos dois temas, como deve ser uma sombra.
  boxShadow: '0 4px 20px -4px hsl(var(--overlay) / 0.1)',
};

/**
 * Linha de cada serie dentro da dica. O Recharts pinta esse texto com a cor da
 * serie, que so garante 3:1; aqui ele volta a ser texto do popover.
 */
export const TOOLTIP_ITEM_STYLE: React.CSSProperties = {
  color: 'hsl(var(--popover-foreground))',
};

export const AXIS_TICK = {
  fontSize: 11,
  fill: 'hsl(var(--muted-foreground))',
};

export const GRID_STROKE = 'hsl(var(--border))';

export const BAR_GRADIENT_ID = 'chartBarGradient';

/**
 * Cores por tipo TEG, para grafico empilhado. Sem consumidor hoje.
 * `Especial` saiu por decisao do cliente (docs/ALVOS.md, "B, modalidade": vale
 * `tipo_veiculo_bancada` = CONVENCIONAL, CRECHE, ACESSIVEL).
 */
export const TIPO_TEG_COLORS: Record<'Comum' | 'Acessível' | 'Creche', string> = {
  Comum: 'hsl(var(--chart-1))',
  Acessível: 'hsl(var(--chart-3))',
  Creche: 'hsl(var(--chart-4))',
};

/** Degrade vertical da barra: do Azul institucional ao Azul Sinalizacao. */
export function BarGradientDef({ id = BAR_GRADIENT_ID }: { id?: string }) {
  return (
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="hsl(var(--chart-1))" />
        <stop offset="100%" stopColor="hsl(var(--chart-5))" />
      </linearGradient>
    </defs>
  );
}
